import { render, staticRenderFns } from "./HandoverSelfService.vue?vue&type=template&id=23d98e20&"
import script from "./HandoverSelfService.vue?vue&type=script&lang=js&"
export * from "./HandoverSelfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports